<template>
  <div class='EnbNave03'>
    <component :is="!Prefes.componentModel03Nave ? 'EnbNave0301' : Prefes.componentModel03Nave.name"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EnbNave0301 from './EnbNave0301'
import EnbNave0302 from './EnbNave0302'
export default {
  name: 'EnbNave03',
  components: { EnbNave0301, EnbNave0302 },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.EnbNave03 {
  width: 100%;
}
</style>
